<!-- Created by henian.xu on 2020/4/15. -->

<template>
    <div class="campus-picker">
        <XIcon
            content="f015"
            class="icon"
            theme="success"
        />
        <div class="selected">选择后的分校名称</div>
        <div class="label">切换</div>
        <XIcon
            class="link"
            content="f012"
            size="small"
            theme="g5"
        />
    </div>
</template>

<script>
export default {
    name: 'CampusPicker',
    data() {
        return {};
    },
};
</script>

<style lang="scss">
.campus-picker {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    min-height: 50px;
    padding: 0 $padding;
    > .icon {
        flex: 0 0 auto;
        margin-right: $margin-small;
    }

    > .selected {
        flex: 1;
        &.noop {
            color: $gray6;
        }
    }
    > .link {
        flex: 0 0 auto;
        margin-left: $margin-small;
    }
}
</style>
